import {ChargeDto} from "../../features/order/order-api";

export const chargeIsDiscount = (charge: ChargeDto) => {
  return charge?.accountingItemCode?.toLowerCase().includes("discount");
};
